export const INIT_PAGE = 1;

// pay attention to the limit page, it should be bigger enough to avoid the issue of pagination (https://github.com/ankeetmaini/react-infinite-scroll-component/issues/380#issue-1690886123)
export const LIMIT_PAGE = 60;

export const NO_LIMIT_PAGE = 9999;

export const DEBOUNCE_TIME = 2000;
